import { useState } from 'react';

const usePaymentHistory = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeAnchor, setActiveAnchor] = useState('');
  const [selectedTrnId, setSelectedTrnId] = useState<string>('');

  const handleMenuClick = (event: any, id: string) => {
    setAnchorEl(event.currentTarget);
    setSelectedTrnId(id);
  };

  const [openDetailsModal, setOpenDetailsModal] = useState(false);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const tableHeader = [
    {
      id: '1',
      name: 'Ödənişin təyinatı',
    },
    {
      id: '2',
      name: 'Ödənişin tarixi',
    },
    {
      id: '3',
      name: 'Məbləğ',
    },
  ];

  return {
    selectedTrnId,
    anchorEl,
    activeAnchor,
    handleMenuClick,
    handleClose,
    tableHeader,
    openDetailsModal,
    setOpenDetailsModal,
  };
};

export default usePaymentHistory;
